// Avatars Images
import Avatar1 from "./img/tmp/avatars/1.png";
import Avatar2 from "./img/tmp/avatars/2.png";
import Avatar3 from "./img/tmp/avatars/3.png";
import Avatar4 from "./img/tmp/avatars/4.png";
import Avatar5 from "./img/tmp/avatars/5.png";
import Avatar6 from "./img/tmp/avatars/6.png";
import Avatar7 from "./img/tmp/avatars/7.png";
import Avatar8 from "./img/tmp/avatars/8.png";
import Avatar9 from "./img/tmp/avatars/9.png";
import Avatar10 from "./img/tmp/avatars/10.png";
import Avatar11 from "./img/tmp/avatars/11.png";
import Avatar12 from "./img/tmp/avatars/12.png";
import Avatar13 from "./img/tmp/avatars/13.png";
import Avatar14 from "./img/tmp/avatars/14.png";
import Avatar15 from "./img/tmp/avatars/15.png";
import Avatar16 from "./img/tmp/avatars/16.png";
import Avatar17 from "./img/tmp/avatars/17.png";
import Avatar18 from "./img/tmp/avatars/18.png";
import Avatar19 from "./img/tmp/avatars/19.png";

// Default Card Thumbnails Images
import Thumbnail1 from "./img/tmp/thumbnails/1.jpg";
import Thumbnail2 from "./img/tmp/thumbnails/2.jpg";
import Thumbnail3 from "./img/tmp/thumbnails/3.jpg";
import Thumbnail4 from "./img/tmp/thumbnails/4.jpg";
import Thumbnail5 from "./img/tmp/thumbnails/5.jpg";
import Thumbnail6 from "./img/tmp/thumbnails/6.jpg";
import Thumbnail7 from "./img/tmp/thumbnails/7.jpg";
import Thumbnail8 from "./img/tmp/thumbnails/8.jpg";
import Thumbnail9 from "./img/tmp/thumbnails/9.jpg";
import Thumbnail10 from "./img/tmp/thumbnails/10.jpg";
import Thumbnail11 from "./img/tmp/thumbnails/11.jpg";
import Thumbnail12 from "./img/tmp/thumbnails/12.jpg";
import Thumbnail13 from "./img/tmp/thumbnails/13.jpg";
import Thumbnail14 from "./img/tmp/thumbnails/14.jpg";
import Thumbnail15 from "./img/tmp/thumbnails/15.jpg";
import Thumbnail16 from "./img/tmp/thumbnails/16.jpg";
import Thumbnail17 from "./img/tmp/thumbnails/17.jpg";
import Thumbnail18 from "./img/tmp/thumbnails/18.jpg";
import Thumbnail19 from "./img/tmp/thumbnails/19.jpg";

// Card Props
// [game, to, state, thumbnail, timeStatus, title, userURL, avatar, verified, description, tournamentKind, viewsCount, timePassed, tags: [""]]

export const LiveCards = [
  {
    state: "live",
    to: "/stream/1",
    thumbnail: Thumbnail1,
    avatar: Avatar1,
    userURL: "/user/1",
    title:
      "Rerun: Apeks vs Cr4zy, Nexus vs Cr4zy, Hellraisers vs Nexus-Vie.gg CS:GO Legend Series Day 6",
    verified: true,
    username: "Randy Lubin",
    tags: ["League of Legends", "competetive"],
  },
  {
    state: "live",
    to: "/stream/2",
    thumbnail: Thumbnail2,
    avatar: Avatar2,
    userURL: "/user/2",
    title: "VCT Stage 3 - Challengers SEA Group Stage Day 1",
    verified: false,
    username: "Kaiya Rhiel",
    tags: ["God Of War", "lol", "competetive"],
  },
  {
    state: "live",
    to: "/stream/3",
    thumbnail: Thumbnail3,
    avatar: Avatar3,
    userURL: "/user/3",
    title: "I build | I attack | But most importantly, I protec|",
    verified: true,
    username: "Kaiya Donin",
    tags: ["PUBG Mobile", "competetive"],
  },
  {
    state: "live",
    to: "/stream/4",
    thumbnail: Thumbnail4,
    avatar: Avatar4,
    userURL: "/user/4",
    title: "☑️!twab 8 AM ET ☑️!pizza ❌!solo !atheon",
    verified: true,
    username: "Maren Saris",
    tags: ["God of War", "war", "competetive"],
  },
  {
    state: "live",
    to: "/stream/2",
    thumbnail: Thumbnail2,
    avatar: Avatar2,
    userURL: "/user/2",
    title:
      "【 Stanley 】8/13 熱身兩把 預計11點多 卡蜜兒鱷魚單挑大賽 抽出Turtle Beach Stealth 700 Gen 2無線電競耳機 15支",
    verified: false,
    username: "Kaiya Rhiel",
    tags: ["God Of War", "competetive"],
  },
  {
    state: "live",
    to: "/stream/3",
    thumbnail: Thumbnail3,
    avatar: Avatar3,
    userURL: "/user/3",
    title: "IT'S FRIYAY! | !discord !merch !social !charity",
    verified: true,
    username: "Kaiya Donin",
    tags: ["PUBG Mobile", "competetive"],
  },
];

export const VideoCards = [
  {
    to: "/Stream/Video/5",
    thumbnail: Thumbnail5,
    avatar: Avatar5,
    userURL: "/user/5",
    title: "🔥PS5 !GIVEAWAY🔥 ~ HADES with CAS! ~ DIABLO 2 RESURRECTED AT 1PM EST!",
    username: "Tatiana Geidt",
    timeStatus: "12:00",
    tags: ["FIFA", "competetive"],
  },
  {
    to: "/Stream/Video/6",
    thumbnail: Thumbnail6,
    avatar: Avatar6,
    userURL: "/user/6",
    title: "🔴 LIVE Acend vs NaVi OFFICIAL WATCH PARTY - VCT EMEA Challengers Playoffs #VCTPartner",
    username: "Roger Schleifer",
    timeStatus: "12:00",
    tags: ["God Of War", "competetive"],
    verified: true,
  },
  {
    to: "/Stream/Video/7",
    thumbnail: Thumbnail7,
    avatar: Avatar7,
    userURL: "/user/7",
    title: "Hello it's been a while | !advanced !evolve",
    username: "Maren Geidt",
    timeStatus: "12:00",
    tags: ["PUBG Mobile", "competetive"],
    verified: true,
  },
  {
    to: "/Stream/Video/8",
    thumbnail: Thumbnail8,
    avatar: Avatar8,
    userURL: "/user/8",
    title: "IRL Day 8: Milano (IT) with @melina || !tts !change !newyt",
    username: "Leo Donin",
    timeStatus: "12:00",
    tags: ["God Of War", "war"],
    verified: true,
  },
  {
    to: "/Stream/Video/7",
    thumbnail: Thumbnail7,
    avatar: Avatar7,
    userURL: "/user/7",
    title: "NEW WARZONE SEASON",
    username: "Maren Geidt",
    timeStatus: "12:00",
    tags: ["PUBG Mobile", "competetive"],
    verified: true,
  },
  {
    to: "/Stream/Video/8",
    thumbnail: Thumbnail8,
    avatar: Avatar8,
    userURL: "/user/8",
    title: "5500 COMP HELP <3 !gear",
    username: "Leo Donin",
    timeStatus: "12:00",
    tags: ["God Of War", "competetive"],
    verified: true,
  },
];

export const TournamentCards = [
  {
    state: "available",
    to: "/tournament/9",
    thumbnail: Thumbnail9,
    avatar: Avatar9,
    userURL: "/user/9",
    title: "Valorant",
    verified: true,
    username: "Randy Vetrovs",
    tournamentKind: "Single Elimination",
  },
  {
    state: "available",
    to: "/tournament/10",
    thumbnail: Thumbnail10,
    avatar: Avatar10,
    userURL: "/user/10",
    title: "Valorant",
    verified: true,
    username: "Davis Westervelt",
    tournamentKind: "Single Elimination",
  },
  {
    state: "available",
    to: "/tournament/11",
    thumbnail: Thumbnail11,
    avatar: Avatar11,
    userURL: "/user/11",
    title: "Valorant",
    verified: true,
    username: "Jaylon Workman",
    tournamentKind: "Single Elimination",
  },
  {
    state: "available",
    to: "/tournament/12",
    thumbnail: Thumbnail12,
    avatar: Avatar12,
    userURL: "/user/12",
    title: "Valorant",
    verified: true,
    username: "Kianna Carder",
    tournamentKind: "Single Elimination",
  },
  {
    state: "available",
    to: "/tournament/11",
    thumbnail: Thumbnail11,
    avatar: Avatar11,
    userURL: "/user/11",
    title: "Valorant",
    verified: true,
    username: "Jaylon Workman",
    tournamentKind: "Single Elimination",
  },
  {
    state: "available",
    to: "/tournament/12",
    thumbnail: Thumbnail12,
    avatar: Avatar12,
    userURL: "/user/12",
    title: "Valorant",
    verified: true,
    username: "Kianna Carder",
    tournamentKind: "Single Elimination",
  },
];

export const MyTournamentCards = [
  {
    to: "/dashboard/1",
    thumbnail: Thumbnail1,
    title: "Fortnite Fall Season",
    username: "Fortnite",
  },
  {
    to: "/dashboard/2",
    thumbnail: Thumbnail2,
    title: "Champions league",
    username: "FIFA 22",
  },
  {
    to: "/dashboard/3",
    thumbnail: Thumbnail3,
    title: "Battlegrounds",
    username: "PUBG",
  },
];

export const ClippedMomentsCards = [
  {
    to: "/videos/13",
    thumbnail: Thumbnail13,
    avatar: Avatar13,
    userURL: "/user/13",
    title: "Saturday vibes streaming from...",
    username: "Wilson Culhane",
    timeStatus: "4:22",
    viewsCount: "22300",
    timePassed: "2020-04-19T12:59-0500",
  },
  {
    to: "/videos/14",
    thumbnail: Thumbnail14,
    avatar: Avatar14,
    userURL: "/user/14",
    title: "solo arena, most points on ...",
    username: "Chance Calzoni",
    timeStatus: "10:55",
    viewsCount: "120",
    timePassed: "2020-04-19T12:59-0500",
  },
  {
    to: "/videos/15",
    thumbnail: Thumbnail15,
    avatar: Avatar15,
    userURL: "/user/15",
    title: "LIVE: Astralis vs OG - BLAS...",
    username: "BLAST",
    timeStatus: "1:55:40",
    viewsCount: "13000",
    timePassed: "2020-04-19T12:59-0500",
  },
  {
    to: "/videos/16",
    thumbnail: Thumbnail16,
    avatar: Avatar16,
    userURL: "/user/16",
    title: "LJL 2021 Spring Split Week 4",
    username: "Miracle Botosh",
    timeStatus: "14:55",
    viewsCount: "12500",
    timePassed: "2020-04-19T12:59-0500",
  },
  {
    to: "/videos/15",
    thumbnail: Thumbnail15,
    avatar: Avatar15,
    userURL: "/user/15",
    title: "LIVE: Astralis vs OG - BLAS...",
    username: "BLAST",
    timeStatus: "1:55:40",
    viewsCount: "13000",
    timePassed: "2020-04-19T12:59-0500",
  },
  {
    to: "/videos/16",
    thumbnail: Thumbnail16,
    avatar: Avatar16,
    userURL: "/user/16",
    title: "LJL 2021 Spring Split Week 4",
    username: "Miracle Botosh",
    timeStatus: "14:55",
    viewsCount: "12500",
    timePassed: "2020-04-19T12:59-0500",
  },
];

export const SiggestedVideoCards = [
  {
    to: "/videos/1",
    thumbnail: Thumbnail17,
    avatar: Avatar17,
    userURL: "/user/17",
    title: "Saturday vibes streamin...",
    username: "Marcus Philips",
    timeStatus: "4:22",
    viewsCount: "22300",
    timePassed: "2020-04-19T12:59-0500",
  },
  {
    to: "/videos/18",
    thumbnail: Thumbnail18,
    avatar: Avatar18,
    userURL: "/user/18",
    title: "solo arena, most points o...",
    username: "Paityn Dokidis",
    timeStatus: "10:55",
    viewsCount: "12000",
    timePassed: "2020-04-19T12:59-0500",
  },
  {
    to: "/videos/18",
    thumbnail: Thumbnail18,
    avatar: Avatar18,
    userURL: "/user/18",
    title: "solo arena, most points o...",
    username: "Paityn Dokidis",
    timeStatus: "10:55",
    viewsCount: "12000",
    timePassed: "2020-04-19T12:59-0500",
  },
  {
    to: "/videos/19",
    thumbnail: Thumbnail19,
    avatar: Avatar19,
    userURL: "/user/19",
    title: "LJL 2021 Spring Split Week 4",
    username: "Miracle Botosh",
    timeStatus: "14:55",
    viewsCount: "12500",
    timePassed: "2020-04-19T12:59-0500",
  },
  {
    to: "/videos/19",
    thumbnail: Thumbnail19,
    avatar: Avatar19,
    userURL: "/user/19",
    title: "LIVE: Astralis vs OG - BLAS...",
    username: "Aspen Press",
    timeStatus: "1:55:40",
    viewsCount: "13000",
    timePassed: "2020-04-19T12:59-0500",
  },
  {
    to: "/videos/17",
    thumbnail: Thumbnail17,
    avatar: Avatar17,
    userURL: "/user/17",
    title: "Saturday vibes streamin...",
    username: "Marcus Philips",
    timeStatus: "4:22",
    viewsCount: "22300",
    timePassed: "2020-04-19T12:59-0500",
  },
  {
    to: "/videos/18",
    thumbnail: Thumbnail18,
    avatar: Avatar18,
    userURL: "/user/18",
    title: "solo arena, most points o...",
    username: "Paityn Dokidis",
    timeStatus: "10:55",
    viewsCount: "12000",
    timePassed: "2020-04-19T12:59-0500",
  },
  {
    to: "/videos/19",
    thumbnail: Thumbnail19,
    avatar: Avatar19,
    userURL: "/user/19",
    title: "LJL 2021 Spring Split Week 4",
    username: "Miracle Botosh",
    timeStatus: "14:55",
    viewsCount: "12500",
    timePassed: "2020-04-19T12:59-0500",
  },
];

export const GameCards = [
  {
    game: "true",
    to: "/game/612ee82b02d8c79b5f69e9f1",
    thumbnail: "https://www.giantbomb.com/a/uploads/scale_large/8/87790/2952214-box_fn.png",
    title: "Fortnite",
    tags: ["action", "competetive"],
  },
  {
    game: "true",
    to: "/game/612ee57287c09a94a33b2837",
    thumbnail: "https://www.giantbomb.com/a/uploads/scale_large/1/13692/2302957-i2cs9uzmq4yua.jpg",
    title: "Counter-Strike",
    tags: ["CS Go", "shooter", "FPS"],
  },
  {
    game: "true",
    to: "/game/612ee77702f0259983c8a626",
    thumbnail: "https://www.giantbomb.com/a/uploads/scale_large/8/87790/3020660-box_mc.png",
    title: "Minecraft",
    tags: ["Adventure Game"],
  },
  {
    game: "true",
    to: "/game/612ee89217cc909c9ebcc8c0",
    thumbnail: "https://www.giantbomb.com/a/uploads/scale_large/0/3699/2463980-grand%20theft%20auto%20v.jpg",
    title: "GTA V",
  },
  {
    game: "true",
    to: "/game/612eec120a70c8a68959f6b7",
    thumbnail: "https://www.giantbomb.com/a/uploads/scale_large/0/26/2723494-call-of-duty-online-2.jpg",
    title: "Call of Duty: war..",
    tags: ["fps", "shooter"],
  },
  {
    game: "true",
    to: "/game/612ef00bf58776af8e014547",
    thumbnail: "https://www.giantbomb.com/a/uploads/scale_large/0/1992/3302615-fifa_21_covers-1-922x1152.png",
    title: "FIFA 22",
    tags: ["Sport game"],
  },
  {
    game: "true",
    to: "/game/612ee3b66f141c8ef24fafa0",
    thumbnail: "https://www.giantbomb.com/a/uploads/scale_large/8/87790/3175371-box_lol.png",
    title: "League of Lege...",
    tags: ["moba", "action"],
  },
  {
    game: "true",
    to: "/game/612eefd37693fdaeb6d30759",
    thumbnail: "https://www.giantbomb.com/a/uploads/scale_large/8/87790/2949245-box_rleague.png",
    title: "Rocket League",
  },
];

export const SidebarChaneels = [
  {
    name: "Marley Torff",
    game: "League of Legends",
    views: "12300",
    src: Avatar1,
    url: "username",
  },
  {
    name: "Abram Bergson",
    game: "Chess",
    views: "33800",
    src: Avatar2,
    url: "username",
  },
  {
    name: "Wilson Franci",
    game: "FIFA 21",
    views: "17000",
    src: Avatar3,
    url: "username",
  },
  {
    name: "Rayna Vetrovs",
    game: "League of Legends",
    views: "3300",
    src: Avatar4,
    url: "username",
  },
  {
    name: "Dulce Workman",
    game: "Fortnite",
    views: "114000",
    src: Avatar5,
    url: "username",
  },
  {
    name: "Talan Bator",
    game: "God of War",
    views: "24600",
    src: Avatar6,
    url: "username",
  },
];

export const StreamChatMessages = [
  {
    name: "Manuel",
    message: "Coup ni or regrette délires des reculons,.",
  },
  {
    name: "Evelyn",
    message: "Amet vero eos ipsum magna rebum rebum.",
  },
  {
    name: "Mamie",
    message: "Gubergren elitr ea ipsum dolor est consetetur ea. Et sea.",
  },
  {
    name: "Ellen",
    message: "Sciigxi vidis la @iujn tion kun la alteren al.",
  },
  {
    name: "Jim",
    message: "De venas larga me consume ansioso desnudo al los, con tierra de manos.",
  },
  {
    name: "Fred",
    message:
      "Ein freunde @helle ruft nun kleinem du glück, brust so sie weh bist denkst, von der stürmten sollst ward zuletzt.",
  },
  {
    name: "Linnie",
    message: "Deine gut ergötzt weiter sanft.",
  },
  {
    name: "Alfred",
    message: "Modo tutte il dare ma a sua.",
  },
  {
    name: "Amy",
    message: "Enfant cotons ces des @dans descendais cinquante mois m'ont hippocampes.",
  },
  {
    name: "Jim",
    message: "De venas larga me consume ansioso desnudo al los, con tierra de manos.",
  },
  {
    name: "Fred",
    message:
      "Ein freunde @helle ruft nun kleinem du glück, brust so sie weh bist denkst, von der stürmten sollst ward zuletzt.",
  },
  {
    name: "Linnie",
    message: "Deine gut ergötzt weiter sanft.",
  },
  {
    name: "Alfred",
    message: "Modo tutte il dare ma a sua.",
  },
  {
    name: "Amy",
    message: "Enfant cotons ces des @dans descendais cinquante mois m'ont hippocampes.",
  },
  {
    name: "Jim",
    message: "De venas larga me consume ansioso desnudo al los, con tierra de manos.",
  },
  {
    name: "Fred",
    message:
      "Ein freunde @helle ruft nun kleinem du glück, brust so sie weh bist denkst, von der stürmten sollst ward zuletzt.",
  },
  {
    name: "Linnie",
    message: "Deine gut ergötzt weiter sanft.",
  },
  {
    name: "Alfred",
    message: "Modo tutte il dare ma a sua.",
  },
  {
    name: "Amy",
    message: "Enfant cotons ces des @dans descendais cinquante mois m'ont hippocampes.",
  },
  {
    name: "Jim",
    message: "De venas larga me consume ansioso desnudo al los, con tierra de manos.",
  },
  {
    name: "Fred",
    message:
      "Ein freunde @helle ruft nun kleinem du glück, brust so sie weh bist denkst, von der stürmten sollst ward zuletzt.",
  },
  {
    name: "Linnie",
    message: "Deine gut ergötzt weiter sanft.",
  },
  {
    name: "Alfred",
    message: "Modo tutte il dare ma a sua.",
  },
  {
    name: "Amy",
    message: "Enfant cotons ces des @dans descendais cinquante mois m'ont hippocampes.",
  },
  {
    name: "Jim",
    message: "De venas larga me consume ansioso desnudo al los, con tierra de manos.",
  },
  {
    name: "Fred",
    message:
      "Ein freunde @helle ruft nun kleinem du glück, brust so sie weh bist denkst, von der stürmten sollst ward zuletzt.",
  },
  {
    name: "Linnie",
    message: "Deine gut ergötzt weiter sanft.",
  },
  {
    name: "Alfred",
    message: "Modo tutte il dare ma a sua.",
  },
  {
    name: "Amy",
    message: "Enfant cotons ces des @dans descendais cinquante mois m'ont hippocampes.",
  },
];
